module.exports = __webpack_public_path__ + "static/ru-logo100-web-black-2405282ab25c51c512432db2305c4260.svg";